import React from 'react'
import { Button } from 'hhsoig-design-system-core'
import css from './pages.module.css'

export const PreviouslyReportedWarning = () => {
  return (
    <div>
      <h1>You have previously reported to HHS-OIG</h1>
      <p>
        If you have new information about a previously filed complaint, please
        proceed. Every new tip we receive is important.{' '}
      </p>
      <p>
        However, if you are submitting the same information because you have not
        been contacted by an investigator, please understand that resubmitting
        your complaint will not expedite an investigation. Due to the high
        volume of complaints, it is not possible to contact every complainant,
        and it doesn’t mean your complaint is not being investigated.
      </p>
      <p>
        Redundant complaints strain the review process, and reduce efficiency in
        processing unique complaints.
      </p>
      <Button
        variation="primary"
        data-testid="return-to-hhs-tips"
        href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
      >
        Return to HHS-OIG Hotline
      </Button>
      <p>
        <span className={css.boldText}>
          If you wish to continue with your complaint,{' '}
        </span>
        by selecting Acknowledge and continue, you acknowledge that you have
        read and understood that only new information will be considered by a
        reviewing official.
      </p>
    </div>
  )
}
